module.exports = __webpack_public_path__ + "static/media/Developmenticon05.5cbf592c.png";